import { __assign } from "tslib";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import MoaStyledComponent from '../../Style/MoaStyled';
import MuiButton from '@mui/material/Button';
import Font from "../../Style/Font";
import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress, { circularProgressClasses } from '@mui/material/CircularProgress';
import { Color } from "../..";
function CustomCircularProgress(_a) {
    var _b;
    var color = _a.color;
    return (_jsxs(Box, { sx: { position: 'relative', display: 'flex', opacity: 0.3 }, children: [_jsx(CircularProgress, { variant: "determinate", sx: {
                    // color: (theme) => theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
                    color: color === "negative" ? Color.primaryNegative.enable : Color.primary.enable,
                }, size: 15, thickness: 4, value: 100 }), _jsx(CircularProgress, { variant: "indeterminate", disableShrink: true, sx: (_b = {
                        // color: (theme) => (theme.palette.mode === 'light' ? Color.primary.enable_strock : '#308fe8'),
                        color: color === "negative" ? Color.primaryNegative.white : Color.primary.enable_strock,
                        animationDuration: '550ms',
                        position: 'absolute',
                        left: 0
                    },
                    _b["& .".concat(circularProgressClasses.circle)] = {
                        strokeLinecap: 'round',
                    },
                    _b), size: 15, thickness: 4 })] }));
}
var StyledComponent = styled(function (props) {
    var variant = props.variant, disabled = props.disabled, width = props.width, onClick = props.onClick, color = props.color, children = props.children, loading = props.loading;
    var commonButtonProps = React.useMemo(function () { return ({
        disableFocusRipple: true,
        disableRipple: true,
        disableElevation: true,
    }); }, []);
    var commonButtonStyle = React.useMemo(function () { return ({
        width: "".concat(width),
        display: "inline-flex",
        height: "1.75rem",
        padding: "0.625rem 1.25rem",
        justifyContent: "center",
        alignItems: "center",
        gap: "0.25rem",
        flexShrink: 0,
        borderRadius: "0.25rem",
        //text
        textAlign: "center",
        fontFeatureSettings: Font.fontFeatureSettings,
        fontFamily: Font.fontFamily,
        fontSize: "0.75rem",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "0.875rem",
        textTransform: "none",
    }); }, [width]);
    var CustomButtonStyleByVariant = React.useCallback(function (_a) {
        var variant = _a.variant, color = _a.color;
        var borderConfig = variant !== "text" ? "1px solid" : "none";
        var primaryColorConfig = color === "negative" ? "primaryNegative" : "primary";
        var textColorConfig = color === "negative" ? "textNegative" : "text";
        if (variant === "contained") {
            return ({
                border: "".concat(borderConfig, " ").concat(Color[primaryColorConfig].enable_strock),
                background: Color[primaryColorConfig].enable,
                color: Color[textColorConfig].primary,
                "&:hover": {
                    background: Color[primaryColorConfig].hover,
                    color: Color[primaryColorConfig].white,
                    border: "".concat(borderConfig, " ").concat(Color[primaryColorConfig].hover)
                },
                ":active": {
                    background: Color[primaryColorConfig].focus,
                    color: Color[primaryColorConfig].white,
                    border: "".concat(borderConfig, " ").concat(Color[primaryColorConfig].focus)
                },
                ":disabled": {
                    background: Color[primaryColorConfig].enable,
                    color: Color[textColorConfig].disable,
                    border: "".concat(borderConfig, " ").concat(Color[primaryColorConfig].enable)
                },
            });
        }
        if (variant === "outlined") {
            return ({
                border: "".concat(borderConfig, " ").concat(Color[primaryColorConfig].enable_strock),
                background: "none",
                color: Color[textColorConfig].primary,
                "&:hover": {
                    background: "none",
                    color: Color[textColorConfig].primary,
                    border: "".concat(borderConfig, " ").concat(Color[primaryColorConfig].hover)
                },
                ":active": {
                    background: "none",
                    color: Color[textColorConfig].primary,
                    border: "".concat(borderConfig, " ").concat(Color[primaryColorConfig].focus)
                },
                ":disabled": {
                    background: "none",
                    color: Color[textColorConfig].disable,
                    border: "".concat(borderConfig, " ").concat(Color[primaryColorConfig].enable)
                },
            });
        }
        if (variant === "text") {
            return ({
                border: "none",
                background: "none",
                color: Color.secondary.main,
                "&:hover": {
                    background: "none",
                    color: Color[primaryColorConfig].hover,
                    border: "".concat(borderConfig, " ").concat(Color[primaryColorConfig].hover)
                },
                ":active": {
                    background: "none",
                    color: Color[primaryColorConfig].focus,
                    border: "".concat(borderConfig, " ").concat(Color[primaryColorConfig].focus)
                },
                ":disabled": {
                    background: "none",
                    color: Color[textColorConfig].disable,
                    border: "".concat(borderConfig, " ").concat(Color[primaryColorConfig].enable_strock)
                },
            });
        }
        return (_jsx(_Fragment, {}));
    }, []);
    return (_jsx(MuiButton, __assign({ id: (props === null || props === void 0 ? void 0 : props.id) || "" }, commonButtonProps, { variant: variant, disabled: disabled || loading, fullWidth: width === "100%" ? true : false, onClick: onClick, sx: __assign(__assign({}, commonButtonStyle), CustomButtonStyleByVariant({ variant: variant, color: color })), children: loading ?
            _jsx(CustomCircularProgress, { color: color })
            :
                children })));
})(function () { return ({}); });
var ThemedComponent = function (props) { return (_jsx(MoaStyledComponent, { children: _jsx(StyledComponent, __assign({}, props)) })); };
export default ThemedComponent;
